module.exports = __webpack_public_path__ + "img/ski_place7.095575c8.png";